"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Internal = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["href", "anchor", "imgSrc", "platform", "type", "user", "repo", "base", "children"];
var Internal = exports.Internal = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var href = props.href,
    _props$anchor = props.anchor,
    anchor = _props$anchor === void 0 ? {} : _props$anchor,
    imgSrc = props.imgSrc,
    platform = props.platform,
    type = props.type,
    user = props.user,
    repo = props.repo,
    base = props.base,
    children = props.children,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  if (href) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("a", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, anchor), {}, {
      href: href,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", (0, _objectSpread2["default"])({
        alt: "",
        ref: ref,
        src: imgSrc
      }, other))
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", (0, _objectSpread2["default"])({
    alt: "",
    ref: ref,
    src: imgSrc
  }, other));
});
Internal.displayName = 'Internal';